import React from "react";
import Course from './Course.js';
//import FormUpload from "./FormUpload.js";


class PageCourse extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          Course_id: 0,
          Title:"No Course Found",
          TextCourse: "Something went Wrong",
          ButtonValue: "Start Exam",
          ButtonTextSpeech: "Speak it",
          Reload: false,
          pathname:props.location.pathname
        };
      }
      
  componentDidUpdate(){
        if (this.state.Reload)
            this.setState({Reload: false})
  }

  componentDidMount() {
    console.log("componentDidMount");
    console.log(localStorage.getItem("test"));
    
    fetch(process.env.REACT_APP_API_URL + this.state.pathname)
        .then(res =>res.json())
            .then((res) => {
                this.setState({Title:res.courses[0].course_title, TextCourse:res.courses[0].course_data, Course_id:res.courses[0].course_id})
    });
  }
  handleClickLeft() {
    this.setState({ButtonValue: "Exam for Course n" + this.state.CourseNumber + " started" });
    console.log(this.state.ButtonValue);
  }
  handleClickRight(test) {
    this.setState({ButtonTextSpeech: "Spoke it"});
    console.log(this.state.ButtonTextSpeech);
    console.log(test);
  }

  relaod() {
        this.setState({Reload: true})
  }

  render() {
  const course = (this.state.Title !== "No Course Found") ? <Course course_id={this.state.Course_id} reload={this.state.Reload} title={this.state.Title} course={this.state.TextCourse} button={this.state.ButtonValue} onClick={i => this.handleClickLeft()}/> : null;
    return (
      <div style={{ marginTop: "100px"}}>
        <div className="Course">
          { course }
        </div>
        {/* <FormUpload reload={() => {this.relaod()}} course_id={this.state.Course_id}/>*/}
      </div>
    );
  }
}

export default PageCourse;


/*import React, { useState, useEffect } from 'react';
import Course from '../PageCourse/Course'; // Update the path as needed
import FormUpload from '../PageCourse/FormUpload'; // Update the path as needed
import { useParams } from 'react-router-dom';

export default function PageCourse() {
  const [courseState, setCourseState] = useState({
    Course_id: 0,
    Title: "No Course Found",
    TextCourse: "Something went Wrong",
    ButtonValue: "Start Exam",
    ButtonTextSpeech: "Speak it",
    Reload: false,
    pathname: ""
  });

  const { slug } = useParams(); // This is how we get the URL parameter in React Router v5
  const title = slug ? slug.replace(/-/g, ' ') : '';

  useEffect(() => {
    async function fetchData() {
      try {
       const response = await fetch(`${process.env.REACT_APP_API_URL}/${slug}`); 
        const data = await response.json();

        if (data.courses && data.courses.length > 0) {
          const course = data.courses[0];
          setCourseState({
            Course_id: course.course_id,
            Title: course.course_title,
            TextCourse: course.course_data,
            ButtonValue: "Start Exam",
            ButtonTextSpeech: "Speak it",
            Reload: false,
           pathname: slug
          });
        }
      } catch (error) {
        console.error("Error fetching course data:", error);
      }
    }

   if (slug) {
      fetchData();
    }
  }, [slug]);


  function handleClickLeft() {
    setCourseState({ ...courseState, ButtonValue: "Exam for Course n" + courseState.Course_id + " started" });
  }

  function handleClickRight(test) {
    setCourseState({ ...courseState, ButtonTextSpeech: "Spoke it" });
    console.log(test);
  }

  function reload() {
    setCourseState({ ...courseState, Reload: true });
  }

  const course = courseState.Title !== "No Course Found" ? (
    <Course
      course_id={courseState.Course_id}
      reload={() => reload()}
      title={courseState.Title}
      course={courseState.TextCourse}
      button={courseState.ButtonValue}
      onClick={i => handleClickLeft()}
    />
  ) : null;

  return (
    <div style={{ marginTop: "100px"}}>
      <div className="Course">
        {course}
      </div>
      <FormUpload reload={() => reload()} course_id={courseState.Course_id} />
    </div>
  );
} */